const QPhoneMask = (value) => {
    let newVal = value.replace('-', '').replace('(', '').replace(')', '').replaceAll(' ', '')
    newVal = newVal.substring(0,10)
    return newVal
}

export default QPhoneMask